import { CompanyEntryDto } from "@advanced-sales-technologies/backend-client/models/CompanyEntryDto";
import { TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import {
  HiBriefcase,
  HiBuildingOffice2,
  HiMapPin,
  HiOutlineBriefcase,
  HiOutlineBuildingOffice2,
  HiOutlineMapPin,
  HiOutlineUser,
  HiUser,
} from "react-icons/hi2";

import { useCompanyDetail } from "@/hooks/api/company/useCompanyDetail";
import { useGetOrgaInfo } from "@/hooks/api/organisation/useGetOrgaInfo";
import SidePanel from "@/components/atoms/SidePanel";
import MyTab from "@/components/atoms/tab/MyTab";
import ComingSoonFeaturedText from "@/components/molecules/company/detail/ComingSoonFeaturedText";
import CompanyDetailHeader from "@/components/molecules/company/detail/overview/basic/CompanyDetailHeader";
import CompanyDetailOverviewTab from "@/components/molecules/company/detail/overview/basic/CompanyDetailOverviewTab";
import StaticModalHandler from "@/components/organisms/StaticModalHandler";

type Props = {
  id: string | null;
  isOpen: boolean;
  onClose: () => void;
  company?: CompanyEntryDto;
};

const CompanyDetailPanel = ({ id, isOpen, onClose, company }: Props) => {
  const { t } = useTranslation();
  const { data: orga } = useGetOrgaInfo();
  const companyDetail = useCompanyDetail({ id: id!, enabled: !!id });

  return (
    <SidePanel
      isOpen={isOpen}
      setIsOpen={onClose}
      header={
        <StaticModalHandler
          selectedCompanies={[company!]}
          hasLists={Boolean(orga?.listCount)}
          button={{ label: t("static.addTo"), size: "2xs" }}
        />
      }
    >
      <CompanyDetailHeader company={companyDetail} />

      {/* TABS - MAIN */}
      <div className={"relative overflow-y-auto pb-10"}>
        <TabGroup>
          <TabList className={"sticky top-0 z-10 flex bg-white"}>
            <MyTab
              label={t("company.detail.tabs.overview.title")}
              activeIcon={HiBuildingOffice2}
              icon={HiOutlineBuildingOffice2}
            />
            <MyTab label={t("company.detail.tabs.employees")} activeIcon={HiUser} icon={HiOutlineUser} />
            <MyTab label={t("company.detail.tabs.locations")} activeIcon={HiMapPin} icon={HiOutlineMapPin} />
            <MyTab label={t("company.detail.tabs.openJobs")} activeIcon={HiBriefcase} icon={HiOutlineBriefcase} />
          </TabList>

          <TabPanels>
            <TabPanel>
              <CompanyDetailOverviewTab company={companyDetail} />
            </TabPanel>
            <TabPanel>
              <ComingSoonFeaturedText featureName={"employees"} />
            </TabPanel>
            <TabPanel>
              <ComingSoonFeaturedText featureName={"locations"} />
            </TabPanel>
            <TabPanel>
              <ComingSoonFeaturedText featureName={"openJobs"} />
            </TabPanel>
          </TabPanels>
        </TabGroup>
      </div>
    </SidePanel>
  );
};

export default CompanyDetailPanel;
